import { defineComponent as te, ref as m, computed as U, openBlock as L, createElementBlock as $, Fragment as Z, renderList as J, createElementVNode as g, normalizeClass as S, renderSlot as T, createTextVNode as ge, toDisplayString as K, watch as Y, onBeforeMount as be, onMounted as se, nextTick as ye, onUnmounted as we, createCommentVNode as Q, pushScopeId as xe, popScopeId as Le, useSlots as $e, mergeProps as ke, withDirectives as Be, vShow as Ee } from "vue";
import ee from "gsap";
import { ScrollTrigger as H } from "gsap/ScrollTrigger";
import { useDebounceFn as Pe } from "@vueuse/core";
import { CustomEase as ve } from "gsap/CustomEase";
let Ie = (a = 21) => crypto.getRandomValues(new Uint8Array(a)).reduce((h, l) => (l &= 63, l < 36 ? h += l.toString(36) : l < 62 ? h += (l - 26).toString(36).toUpperCase() : l > 62 ? h += "-" : h += "_", h), "");
const Ce = ["id", "aria-controls", "aria-expanded"], Se = ["onClick"], Te = ["id", "aria-labelledby", "hidden"], De = {
  name: "Accordion"
}, Ne = /* @__PURE__ */ te({
  ...De,
  props: {
    items: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      default: () => [1]
    },
    active: {
      type: Number,
      default: -1
    },
    index: {
      type: Number,
      default: void 0
    },
    isOpen: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["toggle"],
  setup(a, { emit: h }) {
    const l = h, f = a, i = m(f.active), v = (t) => f.index === void 0 ? t : f.index, o = U(
      () => (t) => f.isOpen === void 0 ? i.value === v(t) : f.isOpen
    ), b = `accordion-${Ie()}`, D = (t) => {
      const d = v(t);
      f.isOpen === void 0 && (i.value === d ? i.value = -1 : i.value = d), l("toggle", d);
    };
    return (t, d) => (L(!0), $(Z, null, J(a.items, (k, n) => (L(), $(Z, {
      key: `${b}-${n}`
    }, [
      g("div", {
        id: `${b}-reed-${v(n)}`,
        class: S([{ "is-active": o.value(n) }, "reed"]),
        "aria-controls": `${b}-bellows-${v(n)}`,
        "aria-expanded": o.value(n)
      }, [
        g("button", {
          class: "trigger",
          onClick: (B) => D(n)
        }, [
          T(t.$slots, "title", { item: k }, () => [
            ge(K(k.title), 1)
          ], !0)
        ], 8, Se),
        T(t.$slots, "icon", { item: k }, void 0, !0)
      ], 10, Ce),
      g("div", {
        id: `${b}-bellows-${v(n)}`,
        role: "region",
        class: "bellows",
        "aria-labelledby": `${b}-reed-${v(n)}`,
        hidden: !o.value(n)
      }, [
        T(t.$slots, "content", { item: k }, void 0, !0)
      ], 8, Te)
    ], 64))), 128));
  }
});
const ae = (a, h) => {
  const l = a.__vccOpts || a;
  for (const [f, i] of h)
    l[f] = i;
  return l;
}, dt = /* @__PURE__ */ ae(Ne, [["__scopeId", "data-v-6bd1d29b"]]), me = (a) => (xe("data-v-dde00620"), a = a(), Le(), a), Re = {
  key: 0,
  class: "carousel__pagination"
}, Me = ["onClick"], Oe = { class: "h-visually-hidden" }, qe = {
  key: 1,
  class: "carousel__controls"
}, Ae = /* @__PURE__ */ me(() => /* @__PURE__ */ g("svg", {
  class: "carousel__prevnext__icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ g("path", { d: "M10.828 12.0003L15.778 16.9503L14.364 18.3643L7.99995 12.0003L14.364 5.63626L15.778 7.05026L10.828 12.0003Z" })
], -1)), Ve = /* @__PURE__ */ me(() => /* @__PURE__ */ g("svg", {
  class: "carousel__prevnext__icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ g("path", { d: "M13.172 11.9997L8.22205 7.04974L9.63605 5.63574L16 11.9997L9.63605 18.3637L8.22205 16.9497L13.172 11.9997Z" })
], -1)), fe = "is_draggable", ze = /* @__PURE__ */ te({
  __name: "Carousel",
  props: {
    /**
     * An array of items content
     */
    items: {
      type: Array,
      required: !0
    },
    /**
     * Whether or not component should will automatically take care of handling full bleed effect by
     * applying padding and negative margin to its root until it is aligned with fullBleedContainer element.
     */
    fullBleed: {
      type: Boolean,
      default: !0
    },
    /**
     * The element acting as container for the full bleed effect. Will default to window.document.body if null
     * Can be an HTMLElement or null
     */
    fullBleedParent: {
      // type: HTMLElement || null, // ⚠️ Throw ReferenceError: HTMLElement is not defined coming from babel-loader...
      required: !1,
      default: null,
      validator(a) {
        return a instanceof HTMLElement || !a;
      }
    },
    /**
     * Whether and when carousel should display previous and next controls buttons.
     * false -> never
     * true -> always (if carousel is scrollable)
     * BreakpointRange -> false outside range, true inside range
     */
    prevNext: {
      type: Boolean || Object,
      required: !1,
      default: !1
    },
    /**
     * Whether and when carousel should display bullet points navigation.
     * false -> never
     * true -> always (if carousel is scrollable)
     * BreakpointRange -> false outside range, true inside range
     */
    bulletPoints: {
      type: Boolean || Object,
      required: !1,
      default: !1
    },
    /**
     * Whether or not the carousel should monitor the scroll progress
     * of the items entering and leaving the carousel scroller viewport.
     * Setting this to true will update the exposed slot props
     * enterProgress and leaveProgress. Those can then be used to scrub an animation.
     */
    scrolltrigger: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Resize debounce amount in MS
     */
    resizeDebounce: {
      type: Number,
      default: 100
    },
    /**
     * Minimum scrollable distance to determine whether carousel is scrollable or not.
     * This mitigate cases where there only is a very small scroll distance
     * which is visually unsignificant yet toggle the display of all the controls.
     */
    scrollThreshold: {
      type: Number,
      default: 10
    },
    /**
     * Duration in S of a programmatically triggered scroll
     */
    scrollDuration: {
      type: Number,
      default: 0.5
    },
    groupItems: {
      type: [Boolean, Number],
      default: 1
    }
  },
  setup(a, { expose: h }) {
    const l = m([]);
    let f = [];
    const i = m(), v = m([]), o = m(void 0);
    let b = 0, D = 0;
    const t = a, d = m(0), k = m(!0), n = m(!1), B = m(t.prevNext), q = m(t.bulletPoints), x = m(!1);
    let _, C;
    Y(
      () => t.items,
      () => {
        j();
      }
    ), Y(
      v,
      () => {
        ee.registerPlugin(H), f.forEach((e) => e.kill()), f = [], v.value.forEach((e, s) => {
          t.scrolltrigger && (f.push(
            new H({
              trigger: e,
              start: () => `center left+=${b}`,
              end: "right left",
              horizontal: !0,
              scroller: o.value,
              onUpdate: ({ progress: c }) => {
                const r = l.value[s];
                r && (r.enterProgress = 1 - c);
              }
            })
          ), f.push(
            new H({
              trigger: e,
              start: "left right",
              end: () => `center right-=${D}`,
              horizontal: !0,
              scroller: o.value,
              onUpdate: ({ progress: c }) => {
                const r = l.value[s];
                r && (r.leaveProgress = c);
              }
            })
          )), _ == null || _.observe(e);
        }), M();
      },
      {
        deep: !0
      }
    ), Y(x, () => {
      w(), p();
    }), be(() => {
      _ = new ResizeObserver(M);
    });
    const N = m(!1);
    let A = 0, V = 0, y;
    const E = m(!1), R = (e, s) => {
      e.preventDefault(), N.value = !0, A = e.pageX - s.offsetLeft, { scrollLeft: V } = s;
    }, z = () => {
      N.value = !1, E.value = !1;
    }, G = (e, s) => {
      e.preventDefault(), clearTimeout(y), y = setTimeout(() => {
        E.value = !1, s.classList.remove(fe);
      }, 100), N.value = !1;
    }, W = (e, s) => {
      if (!N.value)
        return;
      e.preventDefault(), s.classList.add(fe);
      const r = (e.pageX - s.offsetLeft - A) * 1;
      s.scrollLeft = V - r, clearTimeout(y), E.value = !0, y = setTimeout(() => {
        E.value = !1;
      }, 100);
    };
    se(() => {
      window.addEventListener("resize", M), j(), !(!o.value && !i.value) && (i.value.addEventListener("mousedown", (e) => R(e, o.value)), i.value.addEventListener("mouseleave", () => z()), i.value.addEventListener("mouseup", (e) => G(e, o.value)), i.value.addEventListener("mousemove", (e) => W(e, o.value)), ye(() => {
        ne(), P(), w(), p();
      }));
    }), we(() => {
      window.removeEventListener("resize", M), f.forEach((e) => {
        e.kill();
      }), !(!o.value && !i.value) && (i.value.removeEventListener("mousedown", (e) => R(e, o.value)), i.value.removeEventListener("mouseup", (e) => G(e, o.value)), i.value.removeEventListener("mousemove", (e) => W(e, o.value)), i.value.removeEventListener("mouseleave", () => z()));
    });
    const M = Pe(() => {
      P(), ne(), w(), p(), ce(), H.refresh();
    }, t.resizeDebounce), O = (e) => {
      if (!o.value)
        throw new Error("🎠 - No scroller container to scroll");
      const s = v.value[e];
      if (!s)
        throw new Error("🎠 - Target element does not exists");
      const c = X(s);
      C == null || C.kill(), C = ee.to(o.value, {
        scrollLeft: c,
        duration: t.scrollDuration,
        ease: "power2.inOut"
      });
    }, X = (e) => {
      if (!e)
        throw new Error("🎠 - No element to scroll to");
      return e.offsetLeft - b;
    }, le = () => {
      if (!o.value)
        return;
      const e = o.value.scrollLeft + b, s = v.value.reduce(
        (r, I) => Math.abs(I.offsetLeft - e) < Math.abs(r.offsetLeft - e) ? I : r
      );
      if (!s || !s.parentNode)
        return;
      const c = Array.from(s.parentNode.children).indexOf(s);
      d.value = c;
    }, oe = () => {
      o.value ? k.value = o.value.scrollLeft < t.scrollThreshold : k.value = !1;
    }, u = () => {
      o.value ? n.value = Math.abs(
        o.value.scrollWidth - o.value.scrollLeft - o.value.clientWidth
      ) < t.scrollThreshold : n.value = !1;
    }, w = () => {
      if (x.value) {
        if (typeof t.prevNext == "boolean")
          B.value = t.prevNext;
        else if (typeof t.prevNext == "object") {
          const e = t.prevNext, s = typeof e.from > "u" ? -1 / 0 : e.from, c = typeof e.until > "u" ? 1 / 0 : e.until;
          B.value = window.innerWidth >= s && window.innerWidth <= c;
        }
      } else
        B.value = !1;
    }, p = () => {
      if (x.value) {
        if (typeof t.bulletPoints == "boolean")
          q.value = t.bulletPoints;
        else if (typeof t.bulletPoints == "object") {
          const e = t.bulletPoints, s = typeof e.from > "u" ? -1 / 0 : e.from, c = typeof e.until > "u" ? 1 / 0 : e.until;
          q.value = window.innerWidth >= s && window.innerWidth <= c;
        }
      } else
        B.value = !1;
    }, P = () => {
      var e, s;
      o.value && (x.value = ((e = o.value) == null ? void 0 : e.scrollWidth) - ((s = o.value) == null ? void 0 : s.clientWidth) > t.scrollThreshold);
    }, j = () => {
      var e;
      Array.isArray(t.items) ? l.value = (e = t.items) == null ? void 0 : e.map((s) => ({
        content: s,
        enterProgress: 0,
        leaveProgress: 0
      })) : l.value = [];
    }, ne = () => {
      if (!t.fullBleed || !i.value)
        return;
      const e = t.fullBleedParent || window.document.body;
      if (!e)
        throw new Error("🎠 - Full bleed container element does not exists");
      let s = 0, c = e.offsetWidth;
      if (e.tagName !== "BODY") {
        const I = e.getBoundingClientRect();
        s = I.left, c = I.right;
      }
      const r = i.value.getBoundingClientRect();
      b = r.left - s, D = c - r.right, i.value.style.setProperty(
        "--scroller-inline-padding-start",
        `${b}px`
      ), i.value.style.setProperty(
        "--scroller-inline-padding-end",
        `${D}px`
      );
    }, re = (e) => {
      if (typeof t.groupItems == "number" && t.groupItems !== 0)
        return t.groupItems;
      if (t.groupItems === !0 && i.value && o.value) {
        const s = i.value.getBoundingClientRect();
        if (e === 1) {
          const c = o.value.scrollLeft + s.x + s.width;
          for (let r = d.value + 1; r < v.value.length; r++) {
            const I = v.value[r].getBoundingClientRect();
            if (o.value.scrollLeft + I.x + I.width > c)
              return r - d.value;
          }
        } else if (e === -1) {
          const r = v.value[d.value].getBoundingClientRect().left - b >= t.scrollThreshold ? d.value - 1 : d.value, I = v.value[r].getBoundingClientRect(), de = o.value.scrollLeft + I.x + I.width;
          for (let F = r - 1; F > -1; F--) {
            const _e = v.value[F].getBoundingClientRect(), he = o.value.scrollLeft + _e.x;
            if (de - he > s.width)
              return F === 0 ? d.value : d.value - (F + 1);
          }
        }
      }
      return 1;
    }, ie = () => {
      if (!k.value) {
        if (d.value === 0)
          O(0);
        else if (d.value > 0) {
          const e = re(-1);
          O(d.value - e);
        }
      }
    }, ue = () => {
      const e = re(1);
      !n.value && o.value && d.value < v.value.length - e && O(d.value + e);
    }, ce = () => {
      u(), oe(), le();
    };
    return h({
      prev: ie,
      next: ue,
      goTo: O
    }), (e, s) => (L(), $("div", {
      ref_key: "carouselRef",
      ref: i,
      class: "carousel"
    }, [
      g("ol", {
        ref_key: "scrollerRef",
        ref: o,
        class: S(["carousel__scroller", {
          "can-scroll": x.value
        }]),
        onScroll: ce
      }, [
        (L(!0), $(Z, null, J(l.value, (c, r) => (L(), $("li", {
          key: r,
          ref_for: !0,
          ref_key: "carouselItemElsRef",
          ref: v,
          class: "carousel__item",
          "data-carousel-item": ""
        }, [
          T(e.$slots, "item", {
            index: r,
            item: c.content,
            enterProgress: c.enterProgress,
            leaveProgress: c.leaveProgress
          }, void 0, !0)
        ]))), 128))
      ], 34),
      g("div", null, [
        q.value ? (L(), $("ol", Re, [
          (L(!0), $(Z, null, J(l.value, (c, r) => (L(), $("li", {
            key: r,
            class: "carousel__pagination__item"
          }, [
            g("button", {
              class: S(["carousel__pagination__button", {
                active: r === d.value
              }]),
              onClick: (I) => O(r)
            }, [
              g("span", Oe, K(r), 1)
            ], 10, Me)
          ]))), 128))
        ])) : Q("", !0),
        B.value ? (L(), $("div", qe, [
          T(e.$slots, "prevButton", { disabled: k.value }, () => [
            g("button", {
              class: S(["carousel__prevnext prev", { disabled: k.value }]),
              onClick: ie
            }, [
              T(e.$slots, "prevButtonLabel", {}, () => [
                Ae
              ], !0)
            ], 2)
          ], !0),
          T(e.$slots, "nextButton", { disabled: n.value }, () => [
            g("button", {
              class: S(["carousel__prevnext next", { disabled: n.value }]),
              onClick: ue
            }, [
              T(e.$slots, "nextButtonLabel", {}, () => [
                Ve
              ], !0)
            ], 2)
          ], !0)
        ])) : Q("", !0)
      ])
    ], 512));
  }
});
const vt = /* @__PURE__ */ ae(ze, [["__scopeId", "data-v-dde00620"]]), We = { class: "debug" }, je = /* @__PURE__ */ te({
  __name: "Debug",
  setup(a) {
    ee.registerPlugin(ve);
    let h, l = 400;
    const f = async () => {
      await ee.to(".square", {
        xPercent: `+=${l}`,
        duration: 1,
        ease: h
      }).then(), l = -l;
    };
    return se(() => {
      h = ve.create("custom", "M0,0,C1,0,0,1,1,1");
    }), (i, v) => (L(), $("div", We, [
      g("button", {
        class: "square",
        onClick: f
      })
    ]));
  }
});
const ft = /* @__PURE__ */ ae(je, [["__scopeId", "data-v-cf3e5ab0"]]), Fe = "_default-trigger_1iq9s_1", Ue = "_default-option_1iq9s_16", Ke = "_is-selected_1iq9s_20", Ze = "_is-active_1iq9s_23", Ge = "_dropdown_1iq9s_27", Xe = "_label_1iq9s_31", He = "_select_1iq9s_32", Ye = "_trigger_1iq9s_36", Je = "_option_1iq9s_37", Qe = "_list_1iq9s_41", pe = {
  defaultTrigger: Fe,
  defaultOption: Ue,
  isSelected: Ke,
  isActive: Ze,
  dropdown: Ge,
  label: Xe,
  select: He,
  trigger: Ye,
  option: Je,
  list: Qe
}, et = ["id", "aria-hidden"], tt = ["aria-controls", "aria-expanded", "aria-labelledby"], lt = /* @__PURE__ */ g("svg", {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ g("path", { d: "M0,0l12,0l-6,8Z" })
], -1), ot = ["id", "aria-labelledby", "aria-activedescendant"], st = ["id", "aria-selected", "onMousedown"], pt = /* @__PURE__ */ te({
  __name: "Dropdown",
  props: {
    id: {
      type: String,
      // REVIEW: TS ?
      required: !0
    },
    options: {
      type: Array,
      // REVIEW: TS ?
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    // REVIEW: may be some visually-hidden ?
    showLabel: {
      type: Boolean,
      default: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    classes: {
      type: Array,
      default: () => []
    },
    css: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["open", "close", "update:modelValue"],
  setup(a, { emit: h }) {
    const l = a, f = h, i = $e(), v = i.trigger !== void 0, o = i.option !== void 0;
    let b = !1, D = !1;
    const t = m();
    let d, k;
    const n = m(!1), B = m(l.modelValue !== "");
    let q = -1;
    if (B.value) {
      const u = l.options.findIndex((w) => l.modelValue === w.value);
      u !== -1 && (q = u);
    }
    const x = m(q), _ = m(x.value), C = U(
      () => B.value && x.value !== -1 ? l.options[x.value] : { value: void 0 }
    ), N = U(
      () => B.value && x.value !== -1 ? l.options[_.value] : { value: void 0 }
    ), A = U(
      () => C.value.value === void 0 ? l.placeholder : C.value.label
    );
    Y(
      () => l.modelValue,
      (u, w) => {
        u !== w && (x.value = l.options.findIndex((p) => u === p.value), _.value = x.value, B.value = !0);
      }
    );
    let V = "";
    const y = U(
      () => Object.keys(pe).reduce((u, w) => {
        const p = pe[w], P = Object.keys(l.css).find((j) => j === w);
        return u[w] = P ? `${l.css[P]} ${p}` : p, u;
      }, {})
    ), E = () => {
      _.value = x.value, n.value = !0, f("open");
    }, R = () => {
      n.value = !1, f("close");
    }, z = () => {
      n.value ? D && R() : E();
    }, G = () => {
      l.options.length !== 0 && (!b && document.addEventListener("keydown", X), b = !0, E(), D = !1, setTimeout(() => {
        D = !0;
      }, 250));
    }, W = () => {
      document.removeEventListener("keydown", X), b = !1, R(), t.value.blur();
    }, M = () => {
      x.value = _.value, B.value = !0, t.value.focus(), C.value && f("update:modelValue", C.value.value);
    }, O = (u) => {
      const w = (P) => P.toLowerCase().normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");
      V += w(u);
      const p = l.options.findIndex((P) => w(P.label).startsWith(V));
      p > -1 && (_.value = p), clearTimeout(k), k = setTimeout(() => {
        V = "";
      }, 300);
    }, X = (u) => {
      if (!(u.altKey || u.ctrlKey || u.metaKey || u.shiftKey))
        switch (u.preventDefault(), u.key) {
          case "ArrowUp":
            !n.value && E(), _.value = Math.max(_.value - 1, 0);
            break;
          case "ArrowDown":
            !n.value && E(), _.value = Math.min(_.value + 1, l.options.length - 1);
            break;
          case "Home":
            !n.value && E(), _.value = 0;
            break;
          case "End":
            !n.value && E(), _.value = l.options.length - 1;
            break;
          case "Tab":
            W();
            break;
          case "Escape":
            R();
            break;
          case "Enter":
          case " ":
            n.value && M(), z();
            break;
          default:
            u.key.length === 1 && (!n.value && E(), O(u.key));
        }
    }, le = (u) => {
      clearTimeout(d), _.value = u, M(), R();
    }, oe = () => {
      z();
    };
    return se(() => {
      !t.value || l.options.length === 0 || (t.value.addEventListener("focus", G), t.value.addEventListener("blur", () => {
        d = setTimeout(() => {
          n.value && W();
        }, 150);
      }));
    }), (u, w) => a.options.length > 0 ? (L(), $("div", {
      key: 0,
      class: S(y.value.dropdown)
    }, [
      a.label ? (L(), $("div", {
        key: 0,
        id: a.id,
        class: S(["label", [y.value.label]]),
        "aria-hidden": !a.showLabel
      }, K(a.label), 11, et)) : Q("", !0),
      g("div", {
        class: S(["select", y.value.select])
      }, [
        g("button", {
          ref_key: "triggerEl",
          ref: t,
          class: S(["trigger", [y.value.trigger, { [y.value.defaultTrigger]: !v }]]),
          "aria-controls": `${a.id}-listbox`,
          "aria-expanded": n.value,
          "aria-haspopup": "listbox",
          "aria-labelledby": a.id,
          onClick: oe
        }, [
          T(u.$slots, "trigger", ke({
            label: A.value,
            isExpanded: n.value
          }, { triggerLabel: A.value }), () => [
            g("span", null, K(A.value), 1),
            lt
          ])
        ], 10, tt),
        Be(g("ul", {
          id: `${a.id}-listbox`,
          class: S(["list", y.value.list]),
          role: "listbox",
          tabindex: "-1",
          "aria-labelledby": a.id,
          "aria-activedescendant": N.value.value
        }, [
          (L(!0), $(Z, null, J(a.options, (p, P) => (L(), $("li", {
            id: p.value,
            key: `${a.id}-${P}-option`,
            class: S(["option", [
              y.value.option,
              {
                [y.value.defaultOption]: !o,
                [y.value.isActive]: p.value === N.value.value,
                [y.value.isSelected]: p.value === C.value.value,
                "is-active": p.value === N.value.value,
                "is-selected": p.value === C.value.value
              }
            ]]),
            tabindex: "-1",
            role: "option",
            "aria-selected": p.value === N.value.value,
            onMousedown: (j) => le(P)
          }, [
            T(u.$slots, "option", {
              label: p.label
            }, () => [
              ge(K(p.label), 1)
            ])
          ], 42, st))), 128))
        ], 10, ot), [
          [Ee, n.value]
        ])
      ], 2)
    ], 2)) : Q("", !0);
  }
});
export {
  dt as Accordion,
  vt as Carousel,
  ft as Debug,
  pt as Dropdown
};
